/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class FacebookRoutingStatusAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  getStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/facebook_routing_status`);
  }
}

export default new FacebookRoutingStatusAPI();
